export const  currencyUSD = (number) => {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(number)
}
export const currencyDecimal = (number) => {
    return parseFloat(number).toFixed(2);
}